export default __webpack_public_path__ + "static/media/kneereplacement.089d2321.svg";